var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var Rows = function (_a) {
    var onClick = _a.onClick, className = _a.className;
    return (_jsx("svg", __assign({ xmlns: 'http://www.w3.org/2000/svg', width: '25', height: '24', viewBox: '0 0 25 24', fill: 'none', onClick: onClick, className: className }, { children: _jsx("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M6.25 5.5C6.11193 5.5 6 5.61193 6 5.75V8.5H19V5.75C19 5.61193 18.8881 5.5 18.75 5.5H6.25ZM19 10H6V14H19V10ZM19 15.5H6V18.2502C6 18.3883 6.11193 18.5002 6.25 18.5002H18.75C18.8881 18.5002 19 18.3883 19 18.2502V15.5ZM4.5 5.75C4.5 4.7835 5.2835 4 6.25 4H18.75C19.7165 4 20.5 4.7835 20.5 5.75V18.2502C20.5 19.2167 19.7165 20.0002 18.75 20.0002H6.25C5.2835 20.0002 4.5 19.2167 4.5 18.2502V5.75Z', fill: 'white' }) })));
};
export { Rows };
//# sourceMappingURL=Rows.js.map